import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
export type FileMinifiedFragment = { id: string, name: string, description?: string | null, createdAt: string, projectStatus?: Types.FileProjectStatusEnum | null, systemGenerated?: boolean | null, filterQuery?: string | null, category: Types.FileCategoryEnum, meta?: string | null, childrenIds?: Array<string> | null, taskCount?: number | null, dueDate?: string | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, media?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, createdBy?: { name?: string | null, profilePicture?: string | null } | null, clients: Array<{ id: string, clientName: string, clientIcon?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null }>, stages?: Array<{ stageId: string, name: string, progress: number } | null> | null, projectOwner?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };


export type FileMinifiedFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const FileMinifiedFragmentDoc = /*#__PURE__*/ gql`
    fragment FileMinified on FileSchema {
  id
  iconSettings {
    type
    value
  }
  name
  description
  media {
    ...EntityMedia
  }
  createdAt
  projectStatus
  systemGenerated
  filterQuery
  category
  meta
  childrenIds
  taskCount
  createdBy {
    name
    profilePicture
  }
  clients {
    id
    clientName
    clientIcon {
      ...EntityMedia
    }
  }
  stages {
    stageId
    name
    progress
  }
  dueDate
  projectOwner {
    ...User
  }
}
    `;